export const Separator = () => {
    return <div className="text-center opacity-50">- - - - - - -</div>;
};
